/**
 * The coming soon page's default copy (the rule is in `shared.ts`): what a storefront that is not
 * open yet says when its tenant has written nothing of their own. The tenant's words
 * (`storefront_configs.coming_soon_copy`) replace these field by field.
 */
import type { StorefrontComingSoonCopy } from "../storefrontComingSoon.js";

/** The coming soon page's words, in the store's name. */
export interface ComingSoonCopy {
  /** The badge above the headline. */
  eyebrow: string;
  /** The page's h1. */
  headline: string;
  message: string;
  /** One short line under the message; "" for none. */
  note: string;
}

export function defaultComingSoonCopy({
  storeName,
}: {
  /** The store's display name. */
  storeName: string;
}): ComingSoonCopy {
  return {
    eyebrow: "Coming soon",
    headline: `${storeName} opens soon`,
    message: "We're getting everything ready. Follow along for the opening date.",
    note: "",
  };
}

/** The page's words: the tenant's where they wrote any, the default copy elsewhere. */
export function resolveComingSoonCopy(args: {
  storeName: string;
  copy: StorefrontComingSoonCopy;
}): ComingSoonCopy {
  const defaults = defaultComingSoonCopy({ storeName: args.storeName });
  return {
    eyebrow: defaults.eyebrow,
    headline: args.copy.headline || defaults.headline,
    message: args.copy.message || defaults.message,
    note: args.copy.note || defaults.note,
  };
}
